import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import CommonCardHeader from "../../Utils/CommonComponents/CommonCardHeader";
import AddDiscount from "./AddDiscount";
import ListTable from "./ListTable";
import { useDispatch } from "react-redux";
import { fetchDiscounts } from "../../ReduxToolkit/Reducers/AppReducer";
import Loader from "../../Layout/Loader";
import { useSelector } from "react-redux";
import { openView } from "../../ReduxToolkit/Reducers/viewReducer";

export default function Discounts() {
  const { isLoading } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDiscounts());
  }, [dispatch]); // run only once on mount

  return (
    <div className="page-body main-project">
      {isLoading && <Loader />}
      <Container fluid>
        <Row>
          <Col sm={12}>
            <Card>
              <CommonCardHeader title="Discounts" />
              <CardBody>
                <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                  <AddDiscount />
                  <Button
                    onClick={() => dispatch(openView("tier_discounts"))}
                    color="success"
                  >
                    Tier Discounts
                  </Button>
                </div>
                <ListTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
